import { flow } from 'lodash';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { storeSidebarToggled } from '../../store/layoutOptions';
import Layout from './Layout';

const mapStateToProps = state => ({
  sidebarToggled: state.layoutOptions.sidebarToggled
});

const mapDispatchToProps = dispatch => ({
  setSidebarToggled: toggled => {
    dispatch(storeSidebarToggled(toggled));
  }
});

export default flow(connect(mapStateToProps, mapDispatchToProps), withRouter)(
  Layout
);



// WEBPACK FOOTER //
// ../core/src/components/Layout/index.js